import React, { useEffect, useState } from "react";
import {
 Box,
 Button,
 CircularProgress,
 Typography,
 Alert,
 Stack,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
 deletePriceByCar,
 getAllCarPrices,
 getProducts,
} from "../../redux/products/action";
import { getBrands } from "../../redux/admin/action";
import CarPriceForm from "./CarPriceForm";
import CarPriceUpdateForm from "./CarPriceUpdateForm";
import ExcelUpload from "../bulk/ExcelUpload";
import DownloadCarPricesButton from "../../pages/DownloadExcelButtons/DownloadCarPricesButton";

const PricesByCar = () => {
 const dispatch = useDispatch();
 const { productByCarPrice } = useSelector((store) => store.product);

 const [loading, setLoading] = useState(true);
 const [open, setOpen] = useState(false);
 const [updateOpen, setUpdateOpen] = useState(false);
 const [selectedCar, setSelectedCar] = useState(null);

 const fetchData = async () => {
  try {
   await dispatch(getAllCarPrices());
   await dispatch(getBrands());
   await dispatch(getProducts());
  } catch (err) {
   console.error("Data fetch error:", err);
  } finally {
   setLoading(false);
  }
 };

 useEffect(() => {
  fetchData();
 }, []);

 const handleEdit = (row) => {
  setSelectedCar(row.row);
  setUpdateOpen(true);
 };

 const handleDelete = (id) => {
  dispatch(deletePriceByCar(id));
 };

 const columns = [
  { field: "productName", headerName: "Product", flex: 1 },
  { field: "carTitle", headerName: "Car", flex: 1 },
  { field: "variant", headerName: "Variant", flex: 1 },
  { field: "transmission", headerName: "Transmission", flex: 1 },
  { field: "mrp", headerName: "MRP", flex: 1 },
  { field: "givenPrice", headerName: "Given Price", flex: 1 },
  {
   field: "actions",
   headerName: "Actions",
   flex: 1,
   renderCell: (params) => (
    <Stack direction="row" spacing={1}>
     <Button variant="outlined" onClick={() => handleEdit(params)}>
      Edit
     </Button>
     <Button
      variant="outlined"
      color="error"
      onClick={() => handleDelete(params.row._id)}
     >
      Delete
     </Button>
    </Stack>
   ),
  },
 ];

 const rows =
  productByCarPrice?.map((item) => ({
   id: item._id,
   _id: item._id,
   productName: item.productId?.productName || "N/A",
   carTitle: item.carId?.title || "N/A",
   variant: item.variant || "N/A",
   transmission: item.transmission || "N/A",
   mrp: item.mrp || "N/A",
   givenPrice: item.givenPrice || "N/A",
  })) || [];

 if (loading) return <CircularProgress />;

 return (
  <Box p={3}>
   <Typography variant="h4" gutterBottom>
    🚗 Car Prices Management
   </Typography>

   {/* 🔄 Upload / Download / Add */}
   <Stack direction={{ xs: "column", sm: "row" }} spacing={3} mb={3}>
    <ExcelUpload onUpload={fetchData} />
    <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
     ➕ Add Car Price
    </Button>
   </Stack>
   <DownloadCarPricesButton />
   <Box sx={{ height: 550, width: "100%" }}>
    <DataGrid
     rows={rows}
     columns={columns}
     pageSize={10}
     rowsPerPageOptions={[10]}
     disableSelectionOnClick
    />
   </Box>

   {/* Forms */}
   <CarPriceForm
    open={open}
    onClose={() => setOpen(false)}
    onSubmit={() => {
     setOpen(false);
     fetchData();
    }}
   />
   <CarPriceUpdateForm
    open={updateOpen}
    onClose={() => setUpdateOpen(false)}
    onSubmit={() => {
     setUpdateOpen(false);
     fetchData();
    }}
    selectedCar={selectedCar}
   />
  </Box>
 );
};

export default PricesByCar;

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//  Button,
//  Box,
//  Typography,
//  CircularProgress,
//  Table,
//  TableBody,
//  TableCell,
//  TableContainer,
//  TableHead,
//  TableRow,
//  Paper,
// } from "@mui/material";
// import CarPriceForm from "./CarPriceForm";
// import CarPriceUpdateForm from "./CarPriceUpdateForm";
// import {
//  deletePriceByCar,
//  getAllCarPrices,
//  getProducts,
// } from "../../redux/products/action";
// import { getBrands } from "../../redux/admin/action";
// import axios from "axios";

// const PricesByCar = () => {
//  const dispatch = useDispatch();
//  const { productByCarPrice } = useSelector((store) => store.product);

//  const [selectedCar, setSelectedCar] = useState(null);
//  const [selectedVariants, setSelectedVariants] = useState([]);
//  const [open, setOpen] = useState(false);
//  const [updateOpen, setUpdateOpen] = useState(false);
//  const [loading, setLoading] = useState(true);

//  useEffect(() => {
//   const fetchData = async () => {
//    try {
//     await dispatch(getAllCarPrices());
//     await dispatch(getBrands());
//     await dispatch(getProducts());
//    } catch (error) {
//     console.error("Error fetching data:", error);
//    } finally {
//     setLoading(false);
//    }
//   };

//   fetchData();
//  }, [dispatch]);

//  useEffect(() => {
//   console.log("Product by Car Price:", productByCarPrice);
//  }, [productByCarPrice]);

//  const handleVariantSelect = (event, variant) => {
//   if (event.target.checked) {
//    setSelectedVariants([...selectedVariants, variant]);
//   } else {
//    setSelectedVariants(selectedVariants.filter((v) => v._id !== variant._id));
//   }
//  };

//  const handleSubmit = async (data) => {
//   try {
//    await axios.post(`https://app-api.carexpert.org.in/api/price/create`, data);
//    setOpen(false);
//    setSelectedVariants([]);
//    console.log("hello:");
//    dispatch(getAllCarPrices());
//   } catch (error) {
//    console.log("error:", error);
//   }
//  };

//  const handleUpdateSubmit = async (data) => {
//   try {
//    await axios.put(
//     `https://app-api.carexpert.org.in/api/price/${selectedCar._id}`,
//     data
//    );
//    setUpdateOpen(false);
//    setSelectedCar(null);
//    await dispatch(getAllCarPrices()); // Refresh the list
//   } catch (error) {
//    console.log("error:", error);
//   }
//  };

//  const handleEdit = (carPrice) => {
//   setSelectedCar(carPrice);
//   setUpdateOpen(true);
//  };

//  const handleDelete = (id) => {
//   dispatch(deletePriceByCar(id));
//  };

//  if (loading) {
//   return <CircularProgress />;
//  }

//  if (!productByCarPrice || !Array.isArray(productByCarPrice)) {
//   console.error(
//    "Product by Car Price is not an array or is undefined:",
//    productByCarPrice
//   );
//   return (
//    <Typography variant="h6" color="error">
//     No data available or data format is incorrect.
//    </Typography>
//   );
//  }

//  productByCarPrice.forEach((row, index) => {
//   //   console.log(`Row ${index}:`, row);
//  });

//  return (
//   <Box>
//    <Typography variant="h4" gutterBottom>
//     Car Prices
//    </Typography>
//    <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
//     Add Car Price
//    </Button>
//    <TableContainer component={Paper} style={{ marginTop: "16px" }}>
//     <Table>
//      <TableHead>
//       <TableRow>
//        <TableCell>Product ID</TableCell>
//        <TableCell>Car ID</TableCell>
//        <TableCell>Variant</TableCell>
//        <TableCell>Transmission</TableCell>
//        <TableCell>MRP</TableCell>
//        <TableCell>Given Price</TableCell>
//        <TableCell>Actions</TableCell>
//       </TableRow>
//      </TableHead>
//      <TableBody>
//       {productByCarPrice.map((item) => (
//        <TableRow key={item._id}>
//         <TableCell>{item.productId?.productName || "N/A"}</TableCell>
//         <TableCell>{item.carId?.title || "N/A"}</TableCell>
//         <TableCell>{item.variant || "N/A"}</TableCell>
//         <TableCell>{item.transmission || "N/A"}</TableCell>
//         <TableCell>{item.mrp || "N/A"}</TableCell>
//         <TableCell>{item.givenPrice || "N/A"}</TableCell>
//         <TableCell>
//          <Button onClick={() => handleEdit(item)}>Edit</Button>
//          <Button onClick={() => handleDelete(item._id)}>Delete</Button>
//         </TableCell>
//        </TableRow>
//       ))}
//      </TableBody>
//     </Table>
//    </TableContainer>
//    <CarPriceForm
//     open={open}
//     onClose={() => setOpen(false)}
//     onSubmit={handleSubmit}
//     selectedCar={selectedCar}
//     setSelectedCar={setSelectedCar}
//     selectedVariants={selectedVariants}
//     handleVariantSelect={handleVariantSelect}
//    />
//    <CarPriceUpdateForm
//     open={updateOpen}
//     onClose={() => setUpdateOpen(false)}
//     onSubmit={handleUpdateSubmit}
//     selectedCar={selectedCar}
//    />
//   </Box>
//  );
// };

// export default PricesByCar;
